<div class="row" >
    <div class="card">
      <div class="card-body">
        <form [formGroup]="merchantstatusform" (ngSubmit)="CustomerWalletStatusChange(merchantstatusform.value)">
          <div class="row">
            <div class="col-sm-12">
              <div class="mb-12">
                <label class="form-label">Merchant Withdrawl Status<i style="color: red;">*</i></label>
                <select class="form-select" aria-label="Default select example" formControlName="Status" placeholder="Select Customer Status"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.Status.errors}">
                        <option value="null" [disabled]="true" >Merchant Withdrawl Status</option>
                        <option *ngIf="status=='TRANSFER_INITIATED'" value="TRANSFER_COMPLETED" >Complete</option>
                        <option *ngIf="status=='SELF_BANK_TRANSFER_INITIATED'" value="CANCELLED" >Cancel</option>
                </select>
                <div *ngIf="isForm1Submitted && form1.Status.errors?.required" class="invalid-feedback">
                  Please fill this field
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-12">
              <label for="exampleFormControlTextarea1">Remark<i style="color: red;">*</i></label>
              <textarea class="form-control" rows="3" formControlName="Remark"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.Remark.errors}" maxlength="200"></textarea>
              <div *ngIf="isForm1Submitted && form1.Remark.errors?.required" class="invalid-feedback">
                Please fill this field
              </div>
              <div *ngIf="isForm1Submitted && form1.Remark.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
          </div>
  
          <div class="row mt-3 ">
            <div class="col-md-4">
              <button type="submit" class="btn btn-lg btn-primary" 
              [disabled]="this.loading">
                <span  id="loading" role="status" aria-hidden="true"></span>
                Submit</button>
            </div>
          </div>
          
        </form>
    </div>
  </div>
</div>
  
  